import { useState } from 'react';
import { Alert, AlertIcon, Button, Card, HStack, Input, Text, VStack, useToast } from '@chakra-ui/react';
import { useTestAgreementNotification } from '@partiu/api/notifications/hooks';
import { INotification } from '@partiu/api/notifications/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const errorMessage = (error: any) => {
  const data = error?.response?.data;
  if (!data) return 'Não foi possível realizar o teste.';
  return data.detail ?? Object.values(data).flat().join(' ');
};

/** Testa sem disparar para os destinatários e sem salvar nada. */
export function TestNotificationCard({ formData }: { formData: INotification }) {
  const toast = useToast();
  const isPush = formData.notificationType === 'push';
  const [testEmail, setTestEmail] = useState('');

  const mutation = useTestAgreementNotification({
    onSuccess({ data }) {
      toast({
        status: 'success',
        title: isPush ? 'Push validado' : 'E-mail de teste enviado',
        description: isPush
          ? 'O Firebase aceitou a mensagem. Nenhum usuário recebeu o push.'
          : `Enviado somente para ${data.sent_to}.`,
      });
    },
    onError(error) {
      toast({ status: 'error', title: 'Falha no teste', description: errorMessage(error) });
    },
  });

  return (
    <Card padding={4} width="100%">
      <VStack alignItems="flex-start" spacing={3}>
        <Text fontWeight="bold">Testar antes de agendar</Text>
        <Alert status="info" borderRadius="md" fontSize="sm">
          <AlertIcon />
          {isPush
            ? 'Valida o push no Firebase sem entregar para ninguém. Nada é salvo.'
            : 'Envia somente para o e-mail de teste (vazio = o seu e-mail). Nenhum destinatário recebe e nada é salvo.'}
        </Alert>
        <HStack width="100%" flexWrap="wrap">
          {!isPush && (
            <Input
              type="email"
              maxWidth="320px"
              placeholder="E-mail para teste"
              value={testEmail}
              onChange={(event) => setTestEmail(event.target.value)}
            />
          )}
          <Button
            variant="outline"
            isLoading={mutation.isLoading}
            onClick={() => mutation.mutate({ data: formData, testEmail })}
          >
            {isPush ? 'Validar push' : 'Enviar e-mail de teste'}
          </Button>
        </HStack>
      </VStack>
    </Card>
  );
}
